export const BASE_URL = 'https://classecon.com.br';
export const API = 'https://classecon.com.br/apiAppV2';
export const PROXY = 'https://classecon.com.br/apiAppV2';
export const ENVIRONMENT = 'production';
